export default __webpack_public_path__ + "static/media/4.7401a137.jpeg";